<template>
    <div style="height: 100%; overflow: auto">
        <b-card class="sa-card" header="Dati soggetto" header-tag="header">
            <b-row>
                <b-col cols="12" md="6">
                    <label class="sa-label-data">Ragione soggetto</label>
                    <b-form-input v-model="jsonData.ragioneSoggetto" />
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Codice soggetto</label>
                    <b-form-input v-model="jsonData.codiceSoggetto" />
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Identificativo soggetto</label>
                    <b-form-input v-model="jsonData.identificativoSoggetto" />
                </b-col>

                <b-col cols="12" md="4">
                    <label class="sa-label-data">Nome</label>
                    <b-form-input v-model="jsonData.nome" />
                </b-col>

                <b-col cols="12" md="4">
                    <label class="sa-label-data">Cognome</label>
                    <b-form-input v-model="jsonData.cognome" />
                </b-col>

                <b-col cols="12" md="4">
                    <label class="sa-label-data">Sesso</label>
                    <b-form-input v-model="jsonData.sesso" placeholder="M/F" />
                </b-col>

                <b-col cols="12" md="4">
                    <label class="sa-label-data">Data nascita</label>
                    <date-picker format="DD-MM-YYYY" v-model="jsonData.dataNascita" value-type="timestamp" type="datetime" placeholder="Seleziona data nascita" />
                </b-col>

                <b-col cols="12" md="4">
                    <label class="sa-label-data">Regione nascita</label>
                    <b-form-select v-model="jsonData.codiceIstatRegioneNascita" :options="regioniOptions" value-field="codiceIstat" text-field="regione" />
                </b-col>

                <b-col cols="12" md="4">
                    <label class="sa-label-data">Provincia nascita</label>
                    <b-form-select v-model="jsonData.provinciaNascita" :options="provinceNascitaOptions" value-field="sigla" text-field="provincia" />
                </b-col>

                <b-col cols="12" md="6">
                    <label class="sa-label-data">Comune nascita</label>
                    <b-form-select v-model="jsonData.comuneNascitaCodiceIstat" :options="comuniNascitaOptions" value-field="codiceIstat" text-field="comune" />
                </b-col>

                <b-col cols="12" md="6">
                    <label class="sa-label-data">Nazione soggetto</label>
                    <b-form-input v-model="jsonData.nazioneSoggetto" />
                </b-col>
            </b-row>
        </b-card>

        <b-card class="sa-card" header="Contatti" header-tag="header">
            <b-row>
                <b-col cols="12" md="4">
                    <label class="sa-label-data">Telefono</label>
                    <b-form-input v-model="jsonData.telefono" />
                </b-col>

                <b-col cols="12" md="4">
                    <label class="sa-label-data">Email</label>
                    <b-form-input v-model="jsonData.email" />
                </b-col>

                <b-col cols="12" md="4">
                    <label class="sa-label-data">PEC</label>
                    <b-form-input v-model="jsonData.pec" />
                </b-col>
            </b-row>
        </b-card>

        <b-card class="sa-card" header="Indirizzi" header-tag="header">
            <b-row>
                <b-col cols="12" md="6">
                    <label class="sa-label-data">Indirizzo soggetto</label>
                    <b-form-input v-model="jsonData.indirizzoSoggetto" />
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Regione soggetto</label>
                    <b-form-select v-model="jsonData.codiceIstatRegioneSoggetto" :options="regioniOptions" value-field="codiceIstat" text-field="regione" />
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Provincia soggetto</label>
                    <b-form-select v-model="jsonData.provinciaSoggetto" :options="provinceSoggettoOptions" value-field="sigla" text-field="provincia" />
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Comune soggetto</label>
                    <b-form-select v-model="jsonData.localitaSoggetto" :options="comuniSoggettoOptions" value-field="codiceIstat" text-field="comune" />
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">CAP soggetto</label>
                    <b-form-input v-model="jsonData.capSoggetto" />
                </b-col>

                <b-col cols="12" md="6">
                    <label class="sa-label-data">Indirizzo domicilio</label>
                    <b-form-input v-model="jsonData.indirizzoDomicilio" />
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Regione domicilio</label>
                    <b-form-select v-model="jsonData.codiceIstatRegioneDomicilio" :options="regioniOptions" value-field="codiceIstat" text-field="regione" />
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Provincia domicilio</label>
                    <b-form-select v-model="jsonData.provinciaDomicilio" :options="provinceDomicilioOptions" value-field="sigla" text-field="provincia" />
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Comune domicilio</label>
                    <b-form-select v-model="jsonData.comuneDomicilioCodiceIstat" :options="comuniDomicilioOptions" value-field="codiceIstat" text-field="comune" />
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">CAP domicilio</label>
                    <b-form-input v-model="jsonData.capDomicilio" />
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Regione residenza</label>
                    <b-form-select v-model="jsonData.codiceIstatRegioneResidenza" :options="regioniOptions" value-field="codiceIstat" text-field="regione" />
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Provincia residenza</label>
                    <b-form-select v-model="jsonData.provinciaResidenza" :options="provinceResidenzaOptions" value-field="sigla" text-field="provincia" />
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Comune residenza</label>
                    <b-form-select v-model="jsonData.comuneResidenzaCodiceIstat" :options="comuniResidenzaOptions" value-field="codiceIstat" text-field="comune" />
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">CAP residenza</label>
                    <b-form-input v-model="jsonData.capResidenza" />
                </b-col>
            </b-row>
        </b-card>

        <b-card class="sa-card" header="Dati commerciali/contabili" header-tag="header">
            <b-row>
                <b-col cols="12" md="6">
                    <label class="sa-label-data">Codice azienda</label>
                    <b-form-input v-model="jsonData.codiceAzienda" />
                </b-col>

                <b-col cols="12" md="6">
                    <label class="sa-label-data">Codice listino</label>
                    <b-form-input v-model="jsonData.codiceListino" />
                </b-col>

                <b-col cols="12" md="3">
                    <label class="sa-label-data">Codice tipo soggetto</label>
                    <b-form-select v-model="jsonData.codiceTipoSoggetto" :options="codiceTipoSoggettoOptions" value-field="codiceTipoSoggetto" text-field="codiceTipoSoggetto" />
                </b-col>

                <b-col cols="12" md="6">
                    <label class="sa-label-data">Descrizione tipo soggetto</label>
                    <b-form-input v-model="jsonData.descrizioneTipoSoggetto" disabled />
                </b-col>
            </b-row>
        </b-card>

        <b-card class="sa-card" header="Note" header-tag="header">
            <b-row>
                <b-col cols="12" md="6">
                    <label class="sa-label-data">Note soggetto</label>
                    <b-form-textarea v-model="jsonData.noteSoggetto" rows="3" />
                </b-col>
                <b-col cols="12" md="6">
                    <label class="sa-label-data">Note documento</label>
                    <b-form-textarea v-model="jsonData.noteDocumento" rows="3" />
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import UtilityMixin from "../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";

export default {
    components: { DatePicker },
    mixins: [UtilityMixin],
    data() {
        return {
            pathResource: "/contabilitasoggetti",
            pathResourceComune: "/comuni",
            pathResourceProvince: "/province",
            pathResourceRegioni: "/regioni",
            isInitializing: false,
            codiceTipoSoggettoOptions: [{ codice_tipo_soggetto: null, descrizione: "- Seleziona Tipo -" }],
            jsonData: {
                id: null,
                codiceSoggetto: null,
                ragioneSoggetto: null,
                identificativoSoggetto: null,
                nome: null,
                cognome: null,
                sesso: null,
                dataNascita: null,
                nazioneSoggetto: null,
                telefono: null,
                email: null,
                pec: null,
                indirizzoSoggetto: null,
                capSoggetto: null,
                localitaSoggetto: null,
                provinciaSoggetto: null,
                indirizzoDomicilio: null,
                capDomicilio: null,
                comuneDomicilioCodiceIstat: null,
                provinciaDomicilio: null,
                capResidenza: null,
                comuneResidenzaCodiceIstat: null,
                provinciaResidenza: null,
                comuneNascitaCodiceIstat: null,
                provinciaNascita: null,
                codiceIstatRegioneNascita: null,
                codiceIstatRegioneResidenza: null,
                codiceIstatRegioneDomicilio: null,
                codiceIstatRegioneSoggetto: null,
                regioneNascita: null,
                regioneResidenza: null,
                regioneDomicilio: null,
                regioneSoggetto: null,
                noteSoggetto: null,
                noteDocumento: null,
                codiceAzienda: null,
                codiceListino: null,
                codiceTipoSoggetto: null,
                descrizioneTipoSoggetto: null,
            },

            regioniOptions: [{ codiceIstat: null, regione: "- Seleziona Regione -" }],
            provinceNascitaOptions: [{ sigla: null, provincia: "- Seleziona Provincia -" }],
            comuniNascitaOptions: [{ codiceIstat: null, comune: "- Seleziona Comune -" }],
            provinceSoggettoOptions: [{ sigla: null, provincia: "- Seleziona Provincia -" }],
            comuniSoggettoOptions: [{ codiceIstat: null, comune: "- Seleziona Comune -" }],
            provinceDomicilioOptions: [{ sigla: null, provincia: "- Seleziona Provincia -" }],
            comuniDomicilioOptions: [{ codiceIstat: null, comune: "- Seleziona Comune -" }],
            provinceResidenzaOptions: [{ sigla: null, provincia: "- Seleziona Provincia -" }],
            comuniResidenzaOptions: [{ codiceIstat: null, comune: "- Seleziona Comune -" }],
        };
    },

    mounted() {
        let me = this;
        me.$emit("update", me.jsonData);
        me.loadRegioni();
        me.loadCodiceTipoSoggettoOptions();
        let idRoute = me.$route && me.$route.params ? me.$route.params.id : null;
        let idDaCaricare = me.id && me.id !== "-1" ? me.id : idRoute;
        if (idDaCaricare && idDaCaricare !== "-1") {
            me.loadSoggetto(idDaCaricare);
        }
    },

    watch: {
        jsonData: {
            handler(v) {
                this.$emit("update", v);
            },
            deep: true,
        },

        "jsonData.codiceIstatRegioneNascita"(newVal, oldVal) {
            if (this.isInitializing) return;
            if (newVal === oldVal) return;
            this.resetNascitaAfterRegioneChange();
            if (newVal) this.loadProvinceNascitaByRegione(newVal);
        },
        "jsonData.provinciaNascita"(newVal, oldVal) {
            if (this.isInitializing) return;
            if (newVal === oldVal) return;
            this.resetNascitaAfterProvinciaChange();
            if (newVal) this.loadComuniNascitaByProvincia(newVal);
        },

        "jsonData.codiceIstatRegioneSoggetto"(newVal, oldVal) {
            if (this.isInitializing) return;
            if (newVal === oldVal) return;
            this.resetSoggettoAfterRegioneChange();
            if (newVal) this.loadProvinceSoggettoByRegione(newVal);
        },
        "jsonData.provinciaSoggetto"(newVal, oldVal) {
            if (this.isInitializing) return;
            if (newVal === oldVal) return;
            this.resetSoggettoAfterProvinciaChange();
            if (newVal) this.loadComuniSoggettoByProvincia(newVal);
        },

        "jsonData.codiceIstatRegioneDomicilio"(newVal, oldVal) {
            if (this.isInitializing) return;
            if (newVal === oldVal) return;
            this.resetDomicilioAfterRegioneChange();
            if (newVal) this.loadProvinceDomicilioByRegione(newVal);
        },
        "jsonData.provinciaDomicilio"(newVal, oldVal) {
            if (this.isInitializing) return;
            if (newVal === oldVal) return;
            this.resetDomicilioAfterProvinciaChange();
            if (newVal) this.loadComuniDomicilioByProvincia(newVal);
        },

        "jsonData.codiceIstatRegioneResidenza"(newVal, oldVal) {
            if (this.isInitializing) return;
            if (newVal === oldVal) return;
            this.resetResidenzaAfterRegioneChange();
            if (newVal) this.loadProvinceResidenzaByRegione(newVal);
        },
        "jsonData.provinciaResidenza"(newVal, oldVal) {
            if (this.isInitializing) return;
            if (newVal === oldVal) return;
            this.resetResidenzaAfterProvinciaChange();
            if (newVal) this.loadComuniResidenzaByProvincia(newVal);
        },
        "jsonData.codiceTipoSoggetto"(newVal, oldVal) {
            if (this.isInitializing) return;
            if (newVal === oldVal) return;
            this.updateDescrizioneTipoSoggetto();
        },
    },

    methods: {
        init(id) {
            let me = this;
            me.id = id;
        },
        loadSoggetto(id) {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResource + "/" + id, {}, me.loadSoggettoSuccess, me.loadSoggettoError);
        },
        loadSoggettoSuccess(response) {
            let me = this;
            me.isInitializing = true;
            me.jsonData = response.data.data;
            me.updateDescrizioneTipoSoggetto();
            if (this.jsonData.codiceIstatRegioneNascita) this.loadProvinceNascitaByRegione(this.jsonData.codiceIstatRegioneNascita);
            if (this.jsonData.provinciaNascita) this.loadComuniNascitaByProvincia(this.jsonData.provinciaNascita);
            if (this.jsonData.codiceIstatRegioneSoggetto) this.loadProvinceSoggettoByRegione(this.jsonData.codiceIstatRegioneSoggetto);
            if (this.jsonData.provinciaSoggetto) this.loadComuniSoggettoByProvincia(this.jsonData.provinciaSoggetto);
            if (this.jsonData.codiceIstatRegioneDomicilio) this.loadProvinceDomicilioByRegione(this.jsonData.codiceIstatRegioneDomicilio);
            if (this.jsonData.provinciaDomicilio) this.loadComuniDomicilioByProvincia(this.jsonData.provinciaDomicilio);
            if (this.jsonData.codiceIstatRegioneResidenza) this.loadProvinceResidenzaByRegione(this.jsonData.codiceIstatRegioneResidenza);
            if (this.jsonData.provinciaResidenza) this.loadComuniResidenzaByProvincia(this.jsonData.provinciaResidenza);
            me.$nextTick(() => {
                me.isInitializing = false;
            });
        },
        loadSoggettoError(error) {
            console.log("Errore caricamento soggetto", error);
        },

        loadRegioni() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceRegioni, {}, me.loadRegioniSuccess, me.loadRegioniError);
        },
        loadRegioniSuccess(response) {
            let me = this;
            let base = [{ codiceIstat: null, regione: "- Seleziona Regione -" }];
            let list = response.data.data || [];
            me.regioniOptions = [...base, ...list];
        },
        loadRegioniError(error) {
            console.log("Errore caricamento regioni", error);
        },

        loadProvinceNascitaByRegione(codiceRegione) {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceProvince, { regione: codiceRegione }, me.loadProvinceNascitaByRegioneSuccess, me.loadProvinceNascitaByRegioneError);
        },
        loadProvinceNascitaByRegioneSuccess(response) {
            let me = this;
            let base = [{ sigla: null, provincia: "- Seleziona Provincia -" }];
            me.provinceNascitaOptions = [...base, ...(response.data.data || [])];
        },
        loadProvinceNascitaByRegioneError(error) {
            console.log("Errore province nascita", error);
        },

        loadProvinceSoggettoByRegione(codiceRegione) {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceProvince, { regione: codiceRegione }, me.loadProvinceSoggettoByRegioneSuccess, me.loadProvinceSoggettoByRegioneError);
        },
        loadProvinceSoggettoByRegioneSuccess(response) {
            let me = this;
            let base = [{ sigla: null, provincia: "- Seleziona Provincia -" }];
            me.provinceSoggettoOptions = [...base, ...(response.data.data || [])];
        },
        loadProvinceSoggettoByRegioneError(error) {
            console.log("Errore province soggetto", error);
        },

        loadProvinceDomicilioByRegione(codiceRegione) {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceProvince, { regione: codiceRegione }, me.loadProvinceDomicilioByRegioneSuccess, me.loadProvinceDomicilioByRegioneError);
        },
        loadProvinceDomicilioByRegioneSuccess(response) {
            let me = this;
            let base = [{ sigla: null, provincia: "- Seleziona Provincia -" }];
            me.provinceDomicilioOptions = [...base, ...(response.data.data || [])];
        },
        loadProvinceDomicilioByRegioneError(error) {
            console.log("Errore province domicilio", error);
        },

        loadProvinceResidenzaByRegione(codiceRegione) {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceProvince, { regione: codiceRegione }, me.loadProvinceResidenzaByRegioneSuccess, me.loadProvinceResidenzaByRegioneError);
        },
        loadProvinceResidenzaByRegioneSuccess(response) {
            let me = this;
            let base = [{ sigla: null, provincia: "- Seleziona Provincia -" }];
            me.provinceResidenzaOptions = [...base, ...(response.data.data || [])];
        },
        loadProvinceResidenzaByRegioneError(error) {
            console.log("Errore province residenza", error);
        },

        loadComuniNascitaByProvincia(siglaProvincia) {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceComune + "/provincia/" + siglaProvincia, {}, me.loadComuniNascitaByProvinciaSuccess, me.loadComuniNascitaByProvinciaError);
        },
        loadComuniNascitaByProvinciaSuccess(response) {
            let me = this;
            let base = [{ codiceIstat: null, comune: "- Seleziona Comune -" }];
            me.comuniNascitaOptions = [...base, ...(response.data.data || [])];
        },
        loadComuniNascitaByProvinciaError(error) {
            console.log("Errore comuni nascita", error);
        },

        loadComuniSoggettoByProvincia(siglaProvincia) {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceComune + "/provincia/" + siglaProvincia, {}, me.loadComuniSoggettoByProvinciaSuccess, me.loadComuniSoggettoByProvinciaError);
        },
        loadComuniSoggettoByProvinciaSuccess(response) {
            let me = this;
            let base = [{ codiceIstat: null, comune: "- Seleziona Comune -" }];
            me.comuniSoggettoOptions = [...base, ...(response.data.data || [])];
        },
        loadComuniSoggettoByProvinciaError(error) {
            console.log("Errore comuni soggetto", error);
        },

        loadComuniDomicilioByProvincia(siglaProvincia) {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceComune + "/provincia/" + siglaProvincia, {}, me.loadComuniDomicilioByProvinciaSuccess, me.loadComuniDomicilioByProvinciaError);
        },
        loadComuniDomicilioByProvinciaSuccess(response) {
            let me = this;
            let base = [{ codiceIstat: null, comune: "- Seleziona Comune -" }];
            me.comuniDomicilioOptions = [...base, ...(response.data.data || [])];
        },
        loadComuniDomicilioByProvinciaError(error) {
            console.log("Errore comuni domicilio", error);
        },

        loadComuniResidenzaByProvincia(siglaProvincia) {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceComune + "/provincia/" + siglaProvincia, {}, me.loadComuniResidenzaByProvinciaSuccess, me.loadComuniResidenzaByProvinciaError);
        },
        loadComuniResidenzaByProvinciaSuccess(response) {
            let me = this;
            let base = [{ codiceIstat: null, comune: "- Seleziona Comune -" }];
            me.comuniResidenzaOptions = [...base, ...(response.data.data || [])];
        },
        loadComuniResidenzaByProvinciaError(error) {
            console.log("Errore comuni residenza", error);
        },
        resetNascitaAfterRegioneChange() {
            this.jsonData.provinciaNascita = null;
            this.jsonData.comuneNascitaCodiceIstat = null;
            this.provinceNascitaOptions = [{ sigla: null, provincia: "- Seleziona Provincia -" }];
            this.comuniNascitaOptions = [{ codiceIstat: null, comune: "- Seleziona Comune -" }];
        },
        resetNascitaAfterProvinciaChange() {
            this.jsonData.comuneNascitaCodiceIstat = null;
            this.comuniNascitaOptions = [{ codiceIstat: null, comune: "- Seleziona Comune -" }];
        },

        resetSoggettoAfterRegioneChange() {
            this.jsonData.provinciaSoggetto = null;
            this.jsonData.localitaSoggetto = null;
            this.provinceSoggettoOptions = [{ sigla: null, provincia: "- Seleziona Provincia -" }];
            this.comuniSoggettoOptions = [{ codiceIstat: null, comune: "- Seleziona Comune -" }];
        },
        resetSoggettoAfterProvinciaChange() {
            this.jsonData.localitaSoggetto = null;
            this.comuniSoggettoOptions = [{ codiceIstat: null, comune: "- Seleziona Comune -" }];
        },

        resetDomicilioAfterRegioneChange() {
            this.jsonData.provinciaDomicilio = null;
            this.jsonData.comuneDomicilioCodiceIstat = null;
            this.provinceDomicilioOptions = [{ sigla: null, provincia: "- Seleziona Provincia -" }];
            this.comuniDomicilioOptions = [{ codiceIstat: null, comune: "- Seleziona Comune -" }];
        },
        resetDomicilioAfterProvinciaChange() {
            this.jsonData.comuneDomicilioCodiceIstat = null;
            this.comuniDomicilioOptions = [{ codiceIstat: null, comune: "- Seleziona Comune -" }];
        },

        resetResidenzaAfterRegioneChange() {
            this.jsonData.provinciaResidenza = null;
            this.jsonData.comuneResidenzaCodiceIstat = null;
            this.provinceResidenzaOptions = [{ sigla: null, provincia: "- Seleziona Provincia -" }];
            this.comuniResidenzaOptions = [{ codiceIstat: null, comune: "- Seleziona Comune -" }];
        },
        resetResidenzaAfterProvinciaChange() {
            this.jsonData.comuneResidenzaCodiceIstat = null;
            this.comuniResidenzaOptions = [{ codiceIstat: null, comune: "- Seleziona Comune -" }];
        },
        loadCodiceTipoSoggettoOptions() {
            UtilityMixin.methods.loadDataResources("/contabilitasoggettotipi", {}, this.loadCodiceTipoSoggettoOptionsSuccess, this.loadCodiceTipoSoggettoOptionsError);
        },
        loadCodiceTipoSoggettoOptionsSuccess(response) {
            let base = [{ codice_tipo_soggetto: null, descrizione: "- Seleziona Tipo -" }];
            let list = response.data.data.list;
            this.codiceTipoSoggettoOptions = [...base, ...list];
            this.updateDescrizioneTipoSoggetto();
        },
        loadCodiceTipoSoggettoOptionsError(error) {
            console.log("Errore caricamento codice tipo soggetto", error);
        },
        updateDescrizioneTipoSoggetto() {
            let codice = this.jsonData.codiceTipoSoggetto;

            if (!codice) {
                this.jsonData.descrizioneTipoSoggetto = null;
                return;
            }

            let found = this.codiceTipoSoggettoOptions.find((x) => x.codiceTipoSoggetto === codice);

            this.jsonData.descrizioneTipoSoggetto = found ? found.descrizioneTipo : null;
        },
    },
};
</script>

<style scoped></style>
